import { RootState } from '@app/store';

export const selectTutorial = (state: RootState) => state.tutorial;

export const selectTutorialReady = (state: RootState) => state.tutorial.ready;

export const selectTutorialStep = (state: RootState) => state.tutorial.step;

export const selectTutorialFinished = (state: RootState) => state.tutorial.finished;

export const selectBackground = (state: RootState) => state.tutorial.background;
